import React from 'react';
import { graphql } from 'gatsby';
import LinkTo from '@agria/theme/src/components/linkTo/LinkTo';
import { Image } from '@agria/theme/src/components/Image/Image';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

const StyledImage = styled(Image)`
  ${({ theme: { space } }) => css`
    min-width: 190px;
  `};
`;

export const ButtonBarImageLink = ({ data, ...rest }) => (
  <LinkTo to={data?.link?.url}>
    <StyledImage
      src={data?.image?.image?.localFile}
      roundCorners="all"
      alt={data?.link?.url}
    />
  </LinkTo>
);

export const ButtonBarImageLinkQuery = graphql`
  fragment ButtonBarImageLink on UMBRACO_ButtonBarImageLinkComponentType {
    image {
      image {
        ...ButtonBarImage
      }
    }
    link {
      ...Link
    }
  }
`;
